import React from 'react';
import { Link } from 'react-router-dom';
import styles from './WholesaleOrderSuccess.module.css';

const WholesaleOrderSuccess = () => {
    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <h2>Order Confirmed!</h2>
                <p>Your wholesale order has been successfully placed.</p>
                <p>We will contact you soon via WhatsApp for order confirmation and delivery details.</p>
                <div className={styles.actions}>
                    <Link to="/wholesale-dashboard/overview" className={styles.button}>Go to Dashboard</Link>
                    <Link to="/wholesale-dashboard/catalog" className={styles.button}>Continue Shopping</Link>
                </div>
            </div>
        </div>
    );
};

export default WholesaleOrderSuccess; 